import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './actionConfirmModal.css';

function ActionConfirmModal({
  show,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = false,
  icon = 'exclamation-circle',
  itemName,
  itemDetail,
  loading = false,
  onConfirm,
  onCancel,
}) {
  const [visible, setVisible] = useState(show);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setClosing(false);
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }

    if (visible) {
      setClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setClosing(false);
        document.body.style.overflow = '';
      }, 150);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [show, visible]);

  useEffect(() => {
    if (!visible) return undefined;

    const onKeyDown = event => {
      if (event.key === 'Escape' && !loading) {
        onCancel();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [visible, loading, onCancel]);

  if (!visible) return null;

  const backdropClass = closing
    ? 'ssat-action-modal-backdrop ssat-action-modal-backdrop--closing'
    : 'ssat-action-modal-backdrop';

  const accentClass = destructive
    ? 'ssat-action-modal-accent ssat-action-modal-accent--danger'
    : 'ssat-action-modal-accent';

  const iconClass = destructive
    ? 'ssat-action-modal-icon ssat-action-modal-icon--danger'
    : 'ssat-action-modal-icon';

  const confirmClass = destructive
    ? 'ssat-action-modal-btn ssat-action-modal-btn--confirm ssat-action-modal-btn--danger'
    : 'ssat-action-modal-btn ssat-action-modal-btn--confirm';

  return ReactDOM.createPortal(
    <div
      className={backdropClass}
      role="presentation"
      onMouseDown={event => {
        if (event.target === event.currentTarget && !loading) {
          onCancel();
        }
      }}
    >
      <div className="ssat-action-modal-card" role="dialog" aria-modal="true" aria-labelledby="ssat-action-modal-title">
        <div className={accentClass} />
        <div className="ssat-action-modal-content">
          <div className={iconClass}>
            <i className={`fa fa-${icon}`} aria-hidden="true" />
          </div>

          <h3 id="ssat-action-modal-title" className="ssat-action-modal-title">
            {title}
          </h3>

          {message ? <p className="ssat-action-modal-message">{message}</p> : null}

          {itemName ? (
            <div className="ssat-action-modal-item">
              <span className="ssat-action-modal-item-name">{itemName}</span>
              {itemDetail ? <span className="ssat-action-modal-item-detail">{itemDetail}</span> : null}
            </div>
          ) : null}

          <div className="ssat-action-modal-actions">
            <button
              type="button"
              className="ssat-action-modal-btn ssat-action-modal-btn--cancel"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelLabel}
            </button>
            <button type="button" className={confirmClass} onClick={onConfirm} disabled={loading}>
              {loading ? (
                <>
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" /> Processando...
                </>
              ) : (
                confirmLabel
              )}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default ActionConfirmModal;
